export default "__VITE_ASSET__geVDrVGI__"